"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = require("prop-types");
var _dsIcons = require("@olxbr/ds-icons");
var _TipBox = _interopRequireDefault(require("../TipBox"));
var _SecurityBox = _interopRequireDefault(require("../SecurityBox"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
var isTipType = function isTipType(tipType) {
  return !!tipType && typeof tipType.indexOf === 'function' && tipType.indexOf('tip') === 0;
};
var SafetyMessage = function SafetyMessage(props) {
  var text = props.children,
    sender = props.sender,
    receiver = props.receiver,
    tipType = props.type;
  if (isTipType(tipType)) {
    var tip = {
      text: text
    };
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_SecurityBox["default"], {
      senderMessageTip: sender,
      myAccountId: receiver,
      tip: tip,
      subType: tipType
    });
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_TipBox["default"], {
    tip: {
      icon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_dsIcons.TrustShield, {}),
      text: text,
      cta: null
    },
    variant: "information"
  });
};
SafetyMessage.propTypes = {
  children: (0, _propTypes.oneOfType)([_propTypes.array, _propTypes.element, _propTypes.string]).isRequired,
  type: _propTypes.string.isRequired,
  sender: _propTypes.string.isRequired,
  receiver: _propTypes.string.isRequired
};
var _default = exports["default"] = SafetyMessage;